import React from 'react';
import { Popover } from '@blueprintnyc/bpnyc-common-admin';

import './EventStatusIndicator.scss';

const EventStatusIndicator = ({ status }) => {
	const statusText = status === 'ACTIVE' ? 'Active' : 'Inactive';
	return (
		<div className="EventStatusIndicator">
			<Popover content={statusText}>
				<div className={`status ${statusText}`} />
			</Popover>
		</div>
	);
};

export default EventStatusIndicator;
